import { PAGEPATHS } from "../../components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import DataTableWithPopup from "components/longContentTable";
import ReactApexChart from 'react-apexcharts';

const TechnologyStack = (props) => {
    document.title = "Technology Stack";
    const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const [WappyBirdTechData, setWappyBirdTechData] = useState([]);

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Technology Stack", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Technology Stack", breadcrumbItems)
    })

    useEffect(() => {
        const getWapppyBirdData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_WAPPYBIRD_SCAN}/${scanId}`)
                if (data.status) {
                    setWappyBirdTechData(data.data)
                }
            } catch (e) {
                console.error(e);
            }
        }
        getWapppyBirdData()
    }, [scanId])

    return (
        <React.Fragment>
            <Row>
                <Col
                    className="col-12"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'auto auto auto',
                        columnGap: '1em'
                    }}
                >
                    {WappyBirdTechData.length !== 0 && (
                        WappyBirdTechData.map((v, index) => (
                            <Card key={index}>
                                <TableHeader scanName={v.category} scanId={null} />
                                <CardBody
                                    className="search-engine-table"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                >
                                    {v.name.length !== 0 &&
                                        v.name.map((n, i) => (
                                            <span style={{ fontSize: '15px' }} key={i}> {n} </span>
                                        ))
                                    }
                                </CardBody>
                            </Card>
                        ))
                    )}
                </Col>
            </Row>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(TechnologyStack)